export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/industry/indus-banner.jpg'),
          title: '業界',
          description: 'MaesInfoは業界別のカスタムソリューションを提供し、お客様のビジネスと技術ニーズに最適に対応します。豊富なドメイン知識と経験を有しています。',
        component: ''
      }
  ],
  newslist:[
    {
        title: '銀行',
      imgUrl: require('../../assets/images/industry/indus-pic-1.png'),
        description: `
          MaesInfoは銀行が必要とするバリューチェーン全体のITソリューションを提供します。深い業界専門知識、高品質なデリバリ体制、一流のサービス能力により、銀行がデジタル金融市場の変化に適応し、モダンなデジタルビジネスモデルを再構築する支援を行います。<br/>
          提供サービス例：<br/>
            <p class="zh_desc">
            <span> <i></i>次世代デジタルコアバンキングソリューション</span>
            <span> <i></i>国際決済・貿易金融ソリューション</span>
            <span> <i></i>モバイルクライアントと決済ソリューション</span>
            <span> <i></i>リスク・財務データ分析</span>
            </p>
        `
    },
    {
        title: 'ハイテク',
      imgUrl: require('../../assets/images/industry/indus-pic-2.png'),
        description: `
          MaesInfoはハイテク企業が直面する課題を理解しており、特有のリソースとグローバルなベストプラクティスを活用して、企業のイノベーション促進、成長支援、体験向上、運用最適化を支援します。<br/>
          提供サービス例：<br/>
            <p class="zh_desc">
            <span> <i></i>PaaSプラットフォーム</span>
            <span> <i></i>サーバ製品とソリューション</span>
            <span> <i></i>AI向けデータ収集サービス</span>
            <span> <i></i>ソフトウェア製品のビルド/サポート</span>
            </p>
        `
    },
    {
        title: '保険',
      imgUrl: require('../../assets/images/industry/indus-pic-3.png'),
        description: `
        デジタル時代における保険会社の収益成長の維持方法：MaesInfoは保険企業向けに全プロセス統合ソリューションを構築し、能力のボトルネックを突破し、顧客体験を向上させ、サービスモデルを進化させ、効率と競争力を高めます。<br/>
          提供サービス例：<br/>
            <p class="zh_desc">
           高度で包括的なCRMにより顧客獲得、サービス、維持のためのデータ収集と分析を支援します。
            </p>
        `
    },
    {
        title: '金融',
      imgUrl: require('../../assets/images/industry/indus-pic-4.png'),
        description: `
        金融機関のデジタルトランスフォーメーションでは、リスクを回避しつつビジネスモデルを変革し、インターネット+の運営モデルを推進する必要があります。MaesInfoは40か国以上でコンサルティング、アプリ開発、テスト、運用ソリューションを提供しており、市場機会の獲得と意思決定を支援します。<br/>
    私たちの提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>CRMシステム</span>
      <span> <i></i>先物市場データ分析ソリューション</span>
      </p>
        `
    },
    {
        title: '資本市場',
      imgUrl: require('../../assets/images/industry/indus-pic-5.png'),
        description: `
        グローバリゼーションは資本市場に多方面の影響をもたらしており、優れた業績を達成するには新しい経済秩序の動向理解が必要です。デジタル時代、暗号通貨の台頭、モバイル決済の普及、ブロックチェーンの発展により、資本市場企業はデジタル変革を急務としています。MaesInfoは投資銀行、取引所、決済機関、資産運用会社、カストディアン、ブローカー等の変革を支援します。<br/>
      <p class="zh_desc">
      <span> <i></i>フロント/ミドル/バックオフィスの取引業務改善とリスク管理部門の変革</span>
      <span> <i></i>市場インフラサービスで取引所・決済機関のグローバル運用を支援</span>
      <span> <i></i>資産運用向けの次世代ビジネスモデル構築</span>
      </p>
        `
    },
    {
        title: 'ソフトウェア',
      imgUrl: require('../../assets/images/industry/indus-pic-6.png'),
        description:`
        組織の成長に伴い、既製ソフトウェアでは企業環境の要件を満たせなくなることがあります。大企業は独自のビジネスプロセス、データ構造、ワークフローを持ち、これらを満たすためのエンタープライズアプリが必要です。MaesInfoのソフトウェア開発サービスは組織のニーズに合わせたカスタム企業アプリケーションの開発を提供します。開発チームはグローバルなクライアント向けの豊富な構築経験を有します。
    <br/>
    提供例：<br/>
      <p class="zh_desc row">
       <label class="line">
       <span> <i></i>決済処理システム</span>
       <span> <i></i>自動請求システム</span>
       <span> <i></i>CRM（顧客関係管理）</span>
       </label>
       <label class="line">
       <span> <i></i>ERP（企業資源計画）</span>
       <span><i></i>BCP（事業継続計画）</span>
       <span><i></i>RFIDなどのITサービス管理</span>
       </label>
      </p>
        `
    },
    {
        title: 'エネルギー',
      imgUrl: require('../../assets/images/industry/indus-pic-7.png'),
        description: `
        コネクテッドテクノロジーは世界の運用方法を変革します。スーパーコンピューティングとクラウドにより物理ネットワークを統合し、IT/インターネット技術でエネルギー生産・利用向けのスマートプラットフォームとソリューションを提供します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>GISガス管網地理情報システム</span>
      <span> <i></i>コール/ディスパッチセンターソリューション</span>
      <span> <i></i>遠隔データ収集・監視</span>
      <span> <i></i>モバイル業務アプリ</span>
      </p>
        `
    },
    {
        title: 'インターネット',
      imgUrl: require('../../assets/images/industry/indus-pic-8.png'),
        description: `
        MaesInfoはグローバルなデジタルサービス能力を持ち、先進的なデジタル技術を用いて多くの有名インターネット企業に総合的な技術サービスを提供し、従来企業のインターネット変革を支援します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>EC向けカスタマーサポートアウトソーシング</span>
      <span> <i></i>EC体験・インタラクション設計</span>
      <span> <i></i>ソフトウェア・サイトのアクセシビリティテスト</span>
      </p>

        `
    },
    {
        title: '自動車',
      imgUrl: require('../../assets/images/industry/indus-pic-9.png'),
        description: `
        自動車業界は急速に発展しており、5G時代により自動車はスマートフォンや他端末と接続され、音声での操作などより便利でインテリジェントな制御が可能になります。MaesInfoの開発経験と技術力は運用リスク低減と収益改善、優れたインタラクション体験の実現を支援します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>モバイル/デスクトップ向けカスタムソリューション</span>
      <span> <i></i>車載インフォテインメント自動テストサービス</span>
      <span> <i></i>コネクテッドカー開発・車車間通信サービス</span>
      </p>
        `
    },
    {
        title: '医療・ヘルスケア',
      imgUrl: require('../../assets/images/industry/indus-pic-10.png'),
        description: `
        社会の発展に伴い、医療業界は成長鈍化、デジタル変革、統合などの課題と機会に直面しています。複雑さを解消し、スマート医療の新たな形を実現するために、MaesInfoはidoctorプラットフォームを構築し、専門的なケア提供者の発見、コミュニティ、ケア、専門相談、デイケア、生活支援、緊急呼び出しなどのサービスを支援します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>医療業界向けアプリ開発・運用保守サービス</span>
      <span> <i></i>医療向けアプリの開発と運用保守</span>
      </p>
        `
    },
    {
        title: 'メディア・エンターテインメント',
      imgUrl: require('../../assets/images/industry/indus-pic-11.png'),
        description: `
        MaesInfoはメディア・エンターテインメント業界のデジタル変革とモバイル体験の革新を支援します。豊富な実績とカスタムソリューションにより、効率化と技術最適化を実現し、ユーザーに優れた体験を提供します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>映画評価データのスクレイピングと分析</span>
      <span> <i></i>映像作品のトラフィック分析、視聴者分析</span>
      <span> <i></i>モバイルクライアントの構築</span>
      </p>
        `
    },
    {
        title: '教育',
      imgUrl: require('../../assets/images/industry/indus-pic-12.png'),
        description: `
        インターネット技術と教育の融合により、新しい教育形態が生まれています。オンライン教育は世界中の高品質な教育資源を共有し、コストを節約するとともに学習者の視野を広げます。MaesInfoは自社のbbtalkオンライン教育プラットフォームであらゆる年齢層の英語学習を支援します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>教育製品のウェブデザイン</span>
      <span> <i></i>PC・モバイル向けインタラクティブ開発</span>
      <span> <i></i>学習者データ分析</span>
      </p>
        `
    },
    {
        title: '旅行',
      imgUrl: require('../../assets/images/industry/indus-pic-13.png'),
        description: `
        経済のグローバル化と一人当たりGDPの向上に伴い、旅行需要は増加しています。MaesInfoは旅行・交通分野での豊富な経験を活かし、グローバルな旅行・交通企業に対して専門的で効率的なデジタルサービスを提供し、よりスマートな移動体験を創出します。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>ERPコンサルティングと導入</span>
      <span> <i></i>オンラインマーケティングソリューション</span>
      <span> <i></i>モバイルクライアント構築</span>
      </p>
        `
    },
    {
        title: '小売',
      imgUrl: require('../../assets/images/industry/indus-pic-14.png'),
        description: `
        5G時代の到来とECの隆盛は、小売業の従来のオフラインマーケティングに大きな影響を与えています。インターネットとITを効果的に活用して、消費者にパーソナライズされた購買体験を提供し、持続可能な収益モデルを構築する方法が求められています。<br/>
    提供例：<br/>
      <p class="zh_desc">
      <span> <i></i>CRMシステムの運用・保守でマーケティングを高度化</span>
      <span> <i></i>ERPの運用・保守で企業リソースを最適化</span>
      <span> <i></i>フィジカルネットワークプラットフォーム構築</span>
      <span> <i></i>オンラインモールプラットフォーム構築</span>
      <span> <i></i>モバイルクライアント構築と保守</span>
      </p>
        `
    }
  ]
}
